import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import HttpBackend from 'i18next-http-backend';
import EN from '~/static/translations.json';

Vue.use(VueI18Next);

function getI18nextOptions() {
  return {
    // lng: 'en', // <- this is overriding the language detection during the development phase
    fallbackLng: 'en',
    ns: 'common',
    defaultNS: 'common',
    debug: false,
    saveMissing: false,
    backend: {
      backends: [],
      backendOptions: [],
    },
  };
}

function setDebug(i18nextOptions, $config) {
  i18nextOptions.debug = $config.i18NextDebug;
  i18nextOptions.saveMissing = $config.i18NextSaveMissing;
}

/**
 * Add a language detector
 * @see https://github.com/i18next/i18next-browser-languageDetector
 */
function addLanguageDetector(i18nextOptions, $config) {
  i18nextOptions.detection = {
    // order and from where user language should be detected
    order: ['cookie', 'navigator'],

    // keys or params to lookup language from
    lookupCookie: 'i18next',

    // cache user language on
    caches: ['cookie'],

    // optional expire and domain for set cookie
    cookieMinutes: 60 * 24 * 30,
    cookieDomain: $config.ocusCookieDomain,
  };
}

/**
 * Add a local storage cache
 * @see https://github.com/i18next/i18next-localstorage-backend
 */
function addLocalStorageBackend(i18nextOptions, build_id) {
  i18nextOptions.backend.backends.push(LocalStorageBackend);
  i18nextOptions.backend.backendOptions.push({
    // prefix for stored languages
    prefix: `i18next_res_${build_id}_`,

    // expiration
    expirationTime: 7 * 24 * 60 * 60 * 1000,
  });
}

function addHttpBackend(i18nextOptions, build_id, isDev) {
  /**
   * Add XHR backend
   * @see https://github.com/i18next/i18next-xhr-backend
   */
   if (isDev) {
    i18nextOptions.backend.backends.push(resourcesToBackend({
      en: {
        common: EN,
      },
    }));
  } else {
    i18nextOptions.backend.backends.push(HttpBackend);
    i18nextOptions.backend.backendOptions.push({
      loadPath: `/locales/{{lng}}.json?${build_id}`,
    });
  }
}

export default ({
  app, isDev,
}, inject) => {
  /**
   * i18next default options
   * @see https://www.i18next.com/overview/configuration-options
   */
  const i18nextOptions = getI18nextOptions(isDev);
  setDebug(i18nextOptions, app.$config);
  addLanguageDetector(i18nextOptions, app.$config);
  addLocalStorageBackend(i18nextOptions, app.$config.buildId);

  addHttpBackend(i18nextOptions, app.$config.buildId, isDev);

  i18next
    .use(Backend)
    .use(LanguageDetector)
    .init(i18nextOptions);

  const i18n = new VueI18Next(i18next);
  inject('vuei18next', i18n);
  app.i18n = i18n;
};
